import { RectPageEditMode } from './rect-page-edit-mode';
import { PageEditMode } from './page-edit-mode';
import { ApplicationStateService } from '../../services/application-state.service';
import { Inject, Injectable } from '@angular/core';
import { SelectionPageEditMode } from './selection-page-edit-mode';
import { PageTextService } from '../../services/page-text.service';
import { RectService } from '../../services/rect.service';
import { PageDrawing } from '../../models/page-drawing';
import { DrawEditMode } from './draw-edit-mode';
import { CopyingPageEditMode } from './copying-page-edit-mode';
import { ClipboardService } from 'ngx-clipboard';
import { WhiteboardEditMode } from './whiteboard-edit-mode';
import { PageService } from '../../services/page.service';
import { HomeworkEditMode } from './homework-edit-mode';
import { TestEditMode } from './test-edit-mode';
import { WhiteboardDrawing } from '../../models/whiteboard-drawing';
import { BookviewerWhiteboardDrawingsService } from '../../services/bookviewer-whiteboard-drawings.service';

@Injectable({
    providedIn: 'root'
})
export class PageEditModeFactory {
    constructor(@Inject(ApplicationStateService) private applicationStateService: ApplicationStateService,
                @Inject(RectService) private rectService: RectService,
                @Inject(ClipboardService) private clipboardService: ClipboardService,
                @Inject(PageService) private pageService: PageService,
                @Inject(PageTextService) private pageTextService: PageTextService) {

    }

    createRectPageEditMode(): PageEditMode {
        return new RectPageEditMode(
            this.applicationStateService,
            this.rectService
        );
    }

    createTextSelectionPageEditMode(): PageEditMode {
        return new SelectionPageEditMode(
            this.applicationStateService,
            this.pageTextService
        );
    }

    createTextCopyPageEditMode(): PageEditMode {
        return new CopyingPageEditMode(
            this.applicationStateService,
            this.pageTextService,
            this.clipboardService
        );
    }

    createDrawEditMode(pageDrawing: PageDrawing): DrawEditMode {
        return new DrawEditMode(pageDrawing);
    }

    createWhiteboardEditMode(whiteboard: WhiteboardDrawing, whiteboardService: BookviewerWhiteboardDrawingsService): WhiteboardEditMode {
        return new WhiteboardEditMode(whiteboard, whiteboardService, this.pageService);
    }

    createHomeworkEditMode(): HomeworkEditMode {
        return new HomeworkEditMode();
    }

    createTestsEditMode(): TestEditMode {
        return new TestEditMode();
    }
}
